
import { PrismaClient, Prisma, Collection, Role } from '@prisma/client'
import { Component, Vue } from 'vue-property-decorator'
import { NavBar, BreadCrumb, TaskTemplateCard, AssessmentTemplateCard, CreateTaskTemplateModal, ViewTaskTemplateModal, CreateAssessmentTemplateModal, ViewAssessmentTemplateModal } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'
import store from '../store'

@Component({
  components: {
    NavBar,
    BreadCrumb,
    TaskTemplateCard,
    AssessmentTemplateCard,
    CreateTaskTemplateModal,
    ViewTaskTemplateModal,
    CreateAssessmentTemplateModal,
    ViewAssessmentTemplateModal
  }
})
export default class TemplatesView extends Vue {
  data () {
    return {
      activeTab: 0,
      taskTemplates: [],
      assessmentTemplates: [],
      createNewTaskTemplateModal: false,
      createNewAssessmentTemplateModal: false,
      searchTerms: '',
      maxNumOfArtefatos: 10,
      numOfArtefatos: 10,
      numOfWords: 0,
      isLoading: false,
      taskTemplateSearch: '',
      assessmentTemplateSearch: '',
      taskTypes: [],
      assessmentCategories: [],
      assessmentTypes: [],
      viewTaskTemplateId: null,
      viewTaskTemplateObj: { },
      viewAssessmentTemplateId: null,
      viewAssessmentTemplateObj: { },
      activeTaskTemplatePromptResults: [],
      viewTaskTemplateModal: false,
      viewAssessmentTemplateModal: false,
      activeAssessmentTemplatePromptResults: [],
      activeAssessmentTemplates: [],
      activeTaskTemplates: [],
      loggedUserId: null,
      selectedUserId: null
    }
  }

  mounted () {
    this.init(false)
  }

  async init (isReload: boolean) {
    this.loggedUserId = store.getters.getLoggedUserId
    this.selectedUserId = this.$store.getters.getSelectedUserId
    if (this.selectedUserId == null) {
      this.selectedUserId = this.loggedUserId
    }
    if (!isReload) {
      await this.getTaskTypes()
      await this.getAssessmentCategories()
      await this.getAssessmentTypes()
    }

    await this.getActiveAssessmentTemplates()
    await this.getActiveTaskTemplates()
    await this.getTaskTemplates()
    await this.getAssessmentTemplates()
  }

  updateSelectedUserId () {
    this.selectedUserId = this.$store.getters.getSelectedUserId
    this.init(true)
  }

  async getTaskTemplates () {
    this.isLoading = true
    try {
      var urlEnd = this.taskTemplateSearch !== '' ? `/${this.taskTemplateSearch}` : ''
      var url = encodeURI(`${process.env.VUE_APP_SERVERURL}/getTaskTemplates/${this.selectedUserId}` + urlEnd)
      this.taskTemplates = await FetchWrapper.get(url)
      this.taskTemplates.map((e, index) => {
        var idx = this.activeTaskTemplates.findIndex(f => f.id === e.id)
        e.promptResults = []
        e.active = idx > -1
        return 0
      })
      this.isLoading = false
    } catch (e) {
      this.taskTemplates = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get task templates.',
        canCancel: false
      })
    }
  }

  async getTaskTypes () {
    this.isLoading = true
    try {
      this.taskTypes = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getTaskTypes`))
      this.isLoading = false
    } catch (e) {
      this.taskTypes = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get task types.',
        canCancel: false
      })
    }
  }

  async getAssessmentCategories () {
    this.isLoading = true
    try {
      this.assessmentCategories = Object.keys(await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getAssessmentCategories`)))
      this.isLoading = false
    } catch (e) {
      this.assessmentCategories = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get assessment categories.',
        canCancel: false
      })
    }
  }

  async getAssessmentTypes () {
    this.isLoading = true
    try {
      this.assessmentTypes = Object.keys(await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getAssessmentTypes`)))
      this.isLoading = false
    } catch (e) {
      this.assessmentTypes = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get assessment types.',
        canCancel: false
      })
    }
  }

  async getAssessmentTemplates () {
    this.isLoading = true
    try {
      var urlEnd = this.assessmentTemplateSearch !== '' ? `/${this.assessmentTemplateSearch}` : ''
      var url = encodeURI(`${process.env.VUE_APP_SERVERURL}/getAssessmentTemplates/${this.selectedUserId}` + urlEnd)
      this.assessmentTemplates = await FetchWrapper.get(url)
      this.assessmentTemplates.map((e, index) => {
        var idx = this.activeAssessmentTemplates.findIndex(f => f.id === e.id)
        e.promptResults = []
        e.active = idx > -1
        return 0
      })
      this.isLoading = false
    } catch (e) {
      this.assessmentTemplates = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get assessment templates.',
        canCancel: false
      })
    }
  }

  async getActiveAssessmentTemplates () {
    this.isLoading = true
    try {
      this.activeAssessmentTemplates = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getActiveAssessmentTemplates/${this.selectedUserId}`))
      this.isLoading = false
    } catch (e) {
      this.activeAssessmentTemplates = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get active assessment templates.',
        canCancel: false
      })
    }
  }

  async getActiveTaskTemplates () {
    this.isLoading = true
    try {
      this.activeTaskTemplates = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getActiveTaskTemplates/${this.selectedUserId}`))
      this.isLoading = false
    } catch (e) {
      this.activeTaskTemplates = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get active task templates.',
        canCancel: false
      })
    }
  }

  async searchTaskTemplates () {
    await this.getTaskTemplates()
  }

  clearSearchTaskTemplates () {
    this.taskTemplateSearch = ''
  }

  async createNewTaskTemplate () {
    this.createNewTaskTemplateModal = true
  }

  async newTaskTemplateCreated () {
    this.getTaskTemplates()
  }

  async searchAssessmentTemplates () {
    await this.getAssessmentTemplates()
  }

  clearSearchAssessmentTemplates () {
    this.assessmentTemplateSearch = ''
  }

  createNewAssessmentTemplate () {
    this.createNewAssessmentTemplateModal = true
  }

  async newAssessmentTemplateCreated () {
    this.getAssessmentTemplates()
  }

  async openTaskTemplate (id) {
    var idx = this.taskTemplates.findIndex(e => e.id === id)
    this.viewTaskTemplateId = id
    this.viewTaskTemplateObj = {
      id,
      creatorId: this.taskTemplates[idx].creatorId,
      title: this.taskTemplates[idx].title,
      description: this.taskTemplates[idx].description,
      keywords: this.taskTemplates[idx].keywords,
      type: this.taskTemplates[idx].type,
      category: this.taskTemplates[idx].category,
      scorePrompt: this.taskTemplates[idx].scorePrompt,
      prompt: this.taskTemplates[idx].prompt,
      sampleQuote: this.taskTemplates[idx].sampleQuote,
      sampleOutput: this.taskTemplates[idx].sampleOutput,
      active: this.taskTemplates[idx].active
    }
    this.activeTaskTemplatePromptResults = this.taskTemplates[idx].promptResults
    this.viewTaskTemplateModal = true
  }

  async openAssessmentTemplate (id) {
    var idx = this.assessmentTemplates.findIndex(e => e.id === id)
    this.viewAssessmentTemplateId = id
    this.viewAssessmentTemplateObj = {
      id,
      creatorId: this.assessmentTemplates[idx].creatorId,
      title: this.assessmentTemplates[idx].title,
      description: this.assessmentTemplates[idx].description,
      keywords: this.assessmentTemplates[idx].keywords,
      type: this.assessmentTemplates[idx].type,
      category: this.assessmentTemplates[idx].category,
      prompt: this.assessmentTemplates[idx].prompt,
      sampleQuote: this.assessmentTemplates[idx].sampleQuote,
      sampleOutput: this.assessmentTemplates[idx].sampleOutput,
      active: this.assessmentTemplates[idx].active
    }
    this.activeAssessmentTemplatePromptResults = this.assessmentTemplates[idx].promptResults
    this.viewAssessmentTemplateModal = true
  }

  addNewPromptResult ({ id, testQuote, testOutput }) {
    var idx = this.taskTemplates.findIndex(e => e.id === id)
    this.taskTemplates[idx].promptResults.push({ testQuote, testOutput })
    this.activeTaskTemplatePromptResults = this.taskTemplates[idx].promptResults
  }

  addNewAssessmentPromptResult ({ id, testQuote, testOutput }) {
    var idx = this.assessmentTemplates.findIndex(e => e.id === id)
    this.assessmentTemplates[idx].promptResults.push({ testQuote, testOutput })
    this.activeAssessmentTemplatePromptResults = this.assessmentTemplates[idx].promptResults
  }

  addAssTemplateActive (id) {
    var idx = this.activeAssessmentTemplates.findIndex(e => e.id === id)
    if (idx === -1) {
      this.activeAssessmentTemplates.push({ id, active: true })
      this.viewAssessmentTemplateObj.active = true
    }
    var index = this.assessmentTemplates.findIndex(e => e.id === id)
    if (index > -1) {
      this.assessmentTemplates[index].active = true
    }
  }

  removeAssTemplateActive (id) {
    var idx = this.activeAssessmentTemplates.findIndex(e => e.id === id)
    if (idx > -1) {
      this.activeAssessmentTemplates.splice(idx, 1)
      this.viewAssessmentTemplateObj.active = false
    }
    var index = this.assessmentTemplates.findIndex(e => e.id === id)
    if (index > -1) {
      this.assessmentTemplates[index].active = false
    }
  }

  async activeTaskTemplateChanged (id) {
    await this.getActiveTaskTemplates()
    await this.getTaskTemplates()
    await this.openTaskTemplate(id)
  }
}
